import * as constants from './constants';
import {
    fromJS
} from 'immutable';
const defaultState = fromJS({
    project:[],
    live:[],
    experiment:[],
    newProjectList:[],
    newLiveList:[],
    newExperList:[],
    newList:[],
    totalPage:'',
    page:1,
    projectPage:1,
    livePage:1,
    experPage:1,
    categoryList:[],
    categoryData:'',
    searchTitle:'',
    searchCateId:''
})
function clearTypeList(state,action) {
    if(action.types==='project'){
        return state.merge({
            newProjectList:[],
            projectPage:1, 
        })
    }else if(action.types==='live'){
        return state.merge({
            newLiveList:[],
            livePage:1, 
        })
    }else if(action.types==='experiment'){
        return state.merge({
            newExperList:[],
            experPage:1, 
        })
    }
}
function changeTypePage(state,action){
   if(action.types==='project'){
        return state.merge({
             projectPage:action.page
        })
    }else if(action.types==='live'){
        return state.merge({
             livePage:action.page
        })
    }else if(action.types==='experiment'){
        return state.merge({
             experPage:action.page
        })
    }
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.CHANGE_COURSE_PROJECT_DATA:
            return state.merge({
                project: action.data,
                totalPage:action.totalPage
            });
        case constants.CHANGE_COURSE_LIVE_DATA:
            return state.merge({
                live: action.data,
                totalPage:action.totalPage
            });
        case constants.CHANGE_COURSE_EXPERIMENT_DATA:
            return state.merge({
                experiment: action.data,
                totalPage:action.totalPage
            });
        case constants.CHANGE_NEW_LISTS:
            return state.merge({
                newList: state.get('newList').concat(action.newList)
            });
        case constants.CHANGE_NEW_PROJECT_LISTS:
            return state.merge({
                newProjectList:state.get('newProjectList').concat(action.newProjectList)
            });
        case constants.CHANGE_NEW_LIVE_LISTS:
            return state.merge({
                newLiveList:state.get('newLiveList').concat(action.newLiveList)
            });
        case constants.CHANGE_NEW_EXPER_LISTS:
            return state.merge({
                newExperList:state.get('newExperList').concat(action.newExperList)
            }); 
        case constants.CLEAR_NEW_LISTS:
            return clearTypeList(state, action);
        case constants.CHANGE_PAGE_SIZE:
            return changeTypePage(state, action);
        case constants.CLEAR_SEARCH_DATA:
            return state.merge({
               searchTitle:action.searchTitle,
               searchCateId:action.searchCateId
            });
        case constants.CHANGE_CATEGORY_LIST:
            return state.merge({
               categoryList:action.categoryList
            });
        case constants.CHANGE_CATEGORY:
            return state.merge({
               categoryData:action.categoryData
            }); 
        case constants.CHANGE_CATEGORY_ID:
            return state.merge({
               searchCateId:action.searchCateId
            }); 
        case constants.CHANGE_SEARCH_TITLE:
            return state.merge({
               searchTitle:action.searchTitle
            }); 
        default:
            return state;
    }
}

 